export default __webpack_public_path__ + "static/assets/finalized-order-character.a4ad3e96.png";